import { BOOKING_DETAILS_HOLDERS_ROUTE, BOOKING_DETAILS_ROUTE } from '@constants/routes';

export const getBookingDetailsRoute = ({
  bookingId,
  holderCode,
  isHolder,
  clubSlug,
  eventId,
  companyLegacyId,
}: {
  bookingId: string;
  holderCode?: string | null;
  isHolder?: boolean;
  clubSlug: string;
  eventId: string;
  companyLegacyId: string;
}) => {
  const holderRoute = BOOKING_DETAILS_HOLDERS_ROUTE.replace(':companyId', companyLegacyId)
    .replace(':clubSlug', clubSlug)
    .replace(':bookingId', bookingId)
    .replace(':eventId', eventId)
    .replace(':code', holderCode ?? '');
  const bookingRoute = BOOKING_DETAILS_ROUTE.replace(':companyId', companyLegacyId)
    .replace(':clubSlug', clubSlug)
    .replace(':bookingId', bookingId)
    .replace(':eventId', eventId);
  return isHolder ? holderRoute : bookingRoute;
};
